/**
 * MKS-338 — the ONE "does this instance have the robot / Factory™ add-on" check
 * in the SPA. The counterpart of `isRobotEnabled()` in
 * `backend/src/config/robotCapability.ts`; see `docs/private/MODULES.md` §"The robot /
 * Factory™ capability".
 *
 * The capability IS the `monka` module, so this is `hasModule('monka')` behind
 * a name — the same module that already gates `/admin/bot`,
 * `/admin/robot-tasks` and `/connect/:nonce` in `App.tsx` and the two Sidebar
 * entries.
 *
 * It inherits `useModules()`'s deliberate FAIL-OPEN contract (Phase 93, see
 * `docs/private/MODULES.md` §"Frontend gating"): true while `GET /api/modules` loads,
 * on a fetch error, and with no provider mounted. That is safe here because
 * the backend is the enforcement boundary, not this hook — with `monka` off
 * the task card DTO carries no Factory™ state and no robot system labels, the
 * comment DTO carries no `sourceExecutor`, and the triager-proposal routes
 * 404. A brief fail-open window therefore has nothing to render.
 */
import { useModules } from '../services/modulesContext';

export function useRobotEnabled(): boolean {
  return useModules().hasModule('monka');
}
